module.exports = __webpack_public_path__ + "static/media/Покана за свикване на редовното заседание на ОСА на Формопласт АД.2d3940ee.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2022/Покана за свикване на редовното заседание на ОСА на Формопласт АД.pdf
// module id = 99
// module chunks = 0